import { useQuery, UseQueryOptions } from "react-query";
import { getLegalContent } from "../services/legal.service";
import { IRequest } from "../interfaces/authentication.interface";

export function useLegal<T extends any = IRequest<{legalContent: string}>>(
    locale: string,
    options?: UseQueryOptions<any, unknown, T>
) {
    return useQuery({
        queryKey: ["Legal", locale],
        queryFn: () => getLegalContent(locale),
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}
